module.exports = __webpack_public_path__ + "static/media/gothic_bold.df0e7f32.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothic_bold.woff
// module id = 266
// module chunks = 1